export { MediaGrid, type MediaGridProps } from "./MediaGrid";
